import { Skeleton, Typography } from "antd";
import "./previewStates.css";

const { Text } = Typography;

export type SkeletonKind = "pdf-loading" | "office-converting";

export interface PreviewSkeletonProps {
  kind: SkeletonKind;
}

export function PreviewSkeleton({ kind }: PreviewSkeletonProps) {
  const message =
    kind === "office-converting"
      ? "正在将 Word 文档转换为 PDF 以便预览…"
      : "正在加载 PDF…";

  return (
    <div className="jerry-preview-skeleton-wrapper">
      <Text type="secondary">{message}</Text>
      <Skeleton active paragraph={{ rows: 8 }} />
    </div>
  );
}
